import { render, staticRenderFns } from "./FormQuestionTemplate.vue?vue&type=template&id=b1833258&scoped=true"
import script from "./FormQuestionTemplate.vue?vue&type=script&lang=js"
export * from "./FormQuestionTemplate.vue?vue&type=script&lang=js"
import style0 from "./FormQuestionTemplate.vue?vue&type=style&index=0&id=b1833258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1833258",
  null
  
)

export default component.exports